import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import { useEffect, useMemo } from "react";
import BlogPostsTable from "../blog/components/BlogPostsTable.jsx";
import { useNavigate } from "react-router";
import { Box, Typography } from "@mui/material";

export default function BlogIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Was ist neu?", path: "/blog" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <>
      <Box flexDirection="row" display="flex" justifyContent="space-between">
        {/* Page Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h1" gutterBottom>
            Was ist neu?
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Neuesten Funktionen, Verbesserungen sowie Fehlerbehebungen des
            Schadenportals.
          </Typography>
        </Box>
      </Box>

      <BlogPostsTable
        onRowClick={(blogPost) => {
          if (!blogPost || !blogPost.id) {
            return;
          }
          navigate(`/blog/${blogPost.id}`);
        }}
      />
    </>
  );
}
